"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _common = require("_a/common");
var actions = {
  /**
   * 根据dictType查询list，如果有直接查缓存，没有查询数据库
   * @param commit
   * @param state
   * @param dictType
   * @returns {Promise<unknown>}
   */
  getDictListByType: function getDictListByType(_ref, dictType) {
    var commit = _ref.commit,
      state = _ref.state;
    return new Promise(function (resolve, reject) {
      var dictList = state.dict[dictType];
      if (dictList) {
        resolve(dictList);
        return;
      }
      (0, _common.getDictDataByDictType)(dictType).then(function (response) {
        var data = response.data;
        commit('SET_DICT', {
          type: dictType,
          data: data
        });
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  }
};
var _default = exports.default = actions;